import { createContext, useContext, type ReactNode } from "react";
import type { SupportedLocale } from "../../src/core/config";

export interface AppLocaleContextValue {
    locale: SupportedLocale;
    programmeLocale?: string | null;
    setProgrammeLocale: (locale: string | null | undefined) => void;
    setLocale: (locale: SupportedLocale) => void;
}

const AppLocaleContext = createContext<AppLocaleContextValue | null>(null);

export function AppLocaleProvider({ value, children }: { value: AppLocaleContextValue; children: ReactNode }) {
    return <AppLocaleContext.Provider value={value}>{children}</AppLocaleContext.Provider>;
}

export function useAppLocale(): AppLocaleContextValue {
    const context = useContext(AppLocaleContext);
    if (!context) {
        throw new Error("useAppLocale must be used within AppLocaleProvider / LocaleProvider");
    }
    return context;
}

/** Active locale tag only. Prefer this over destructuring when you do not need setters. */
export function useLocale(): SupportedLocale {
    return useAppLocale().locale;
}
